import * as DB from "@/api/repair.js"
import {request as Require} from "@/utils/require.js"
import {Toast} from "vant"

const state = () => ({
    backupMenuPermission: false,
})

const mutations = {
    setMenuPermission(state, payload) {
        state.backupMenuPermission = payload
    },
}

const actions = {
    // 我的申请-列表接口
    async getRepairPermission(context, params) {
        const r = await Require({
            api: DB.getRepairPermission,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },
    // 我的申请-列表接口
    async getApplyList(context, params) {
        const r = await Require({
            api: DB.getApplyList,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },
    // 我的申请-撤销申请接口
    async getApplyRevoke(context, params) {
        const r = await Require({
            api: {
                url: DB.getApplyRevoke.url + '/' + params.id,
                method: "GET",
            },
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },
    // 我的申请-添加报修接口
    async postRepairAdd(context, params) {
        const r = await Require({
            api: DB.postRepairAdd,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },
    // 我的审批-列表接口
    async getAuditList(context, params) {
        const r = await Require({
            api: DB.getAuditList,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },
    // 我的审批-拒绝或者同意操作
    async approveResult(context, params) {
        const r = await Require({
            api: DB.approveResult,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },
    // 报修记录、我的维修-列表接口
    async getRecordList(context, params) {
        const r = await Require({
            api: DB.getRecordList,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },
    // 我的申请、我的审批、报修记录、我的维修-详情接口
    async getRecordDetail(context, params) {
        const r = await Require({
            api: {
                url: DB.getRecordDetail.url + '/' + params.id,
                method: "GET",
            },
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },
    // 我的申请、我的审批、报修记录、我的维修-字典接口
    async getDictionaryList(context, params) {
        const r = await Require({
            api: DB.getDictionaryList,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 我的维修-维修人列表接口
    async getRecordUserSelect(context, params) {
        const r = await Require({
            api: DB.getRecordUserSelect,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 我的维修-分配维修人接口
    async postRepairDistribute(context, params) {
        const r = await Require({
            api: DB.postRepairDistribute,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 我的维修-图片上传
    async commonSingleFileUploadOss(context, params) {
        const r = await Require({
            api: {
                url: DB.commonSingleFileUploadOss.url,
                method: DB.commonSingleFileUploadOss.method,
                // dataType: 'FormData',
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            },
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },
    // 我的维修-详情-维修反馈信息提交
    async postRepairFeedbackAdd(context, params) {
        const r = await Require({
            api: DB.postRepairFeedbackAdd,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}